import React, { Component } from "react";

import { Tabs, Tab } from "material-ui/Tabs";
import Typography from "material-ui-next/Typography";
import Subheader from "material-ui/Subheader";
import Divider from "material-ui/Divider";
import Paper from "material-ui-next/Paper";
import { colors } from "assets";

import { StyledButton, Page, Loadable } from "components/support";

import AccountantAreaGeneralInfo from "./accountant-info";
import AccountantAreaFiscalInfo from "./fiscal-info";
import AccountantAreaInvoiceInfo from "./invoice-info";

export default class AccountantAreaView extends Component {
  render() {
    const { presenter, viewModel } = this.props;
    const { loading, company, errors } = viewModel;

    return (
      <Page>
        <Typography type="display1" className="pb-sm">
          Área do Contador
        </Typography>
        <Loadable loading={loading}>
          <Paper elevation={1}>
            <Subheader>
              Configure as informações tributárias de sua empresa
              <br />
            </Subheader>

            <Divider className="mt-sm" />

            <Tabs
              inkBarStyle={{ backgroundColor: colors.accent.normal }}
              tabItemContainerStyle={{ backgroundColor: colors.primary.dark }}
            >
              <Tab label="Informações Gerais" className="tab-content">
                <AccountantAreaGeneralInfo
                  company={company}
                  errors={errors}
                  onChange={(field, value) =>
                    presenter.onChange("fiscal_informations", field, value)
                  }
                />
              </Tab>
              <Tab label="Informações Tributárias" className="tab-content">
                <AccountantAreaFiscalInfo
                  company={company}
                  onChangeDefaultTaxes={(field, subField, value) =>
                    presenter.onChangeDefaultTaxes(field, subField, value)
                  }
                  onChange={(field, value) =>
                    presenter.onChange("default_taxes", field, value)
                  }
                  errors={errors}
                />
              </Tab>
              <Tab label="Informações de Nota Fiscal" className="tab-content">
                <AccountantAreaInvoiceInfo />
              </Tab>
            </Tabs>

            <Divider className="mt-sm" />

            <div className="text-right p-sm">
              <StyledButton
                label="Salvar Informações"
                primary={true}
                className="product__submit"
                onTouchTap={() => presenter.onSendForm()}
              >
                Salvar Produto
              </StyledButton>
            </div>
          </Paper>
        </Loadable>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/accountant-area/view.jsx